import { html, View } from 'rune-ts';
import { getSharedData, type SharedData } from '../../../util';
import type { Button } from '../Button/Button';
import { Input } from '../Input/Input';
import { Typo } from '../Typo/Typo';
import klass from './Label.module.scss';

export interface LabelData {
  label?: string;
  input?: Input;
  button?: Button;
}

export interface LabelOption {
  required?: boolean;
  for_id?: string;
  theme?: SharedData['theme'];
}

export class Label extends View<LabelData> {
  constructor(
    data: LabelData,
    public option: LabelOption = {},
  ) {
    super(data);
  }

  override template() {
    const { required, for_id } = this.option;
    const theme = this.option.theme ?? getSharedData(this).theme;

    return html`<div
      class="${klass.label_container} ${this.data.input && !this.data.button ? klass.only_input_container : ''}"
    >
      <label ${for_id ? html`for=${for_id}` : ''} class="${klass.label}">
        ${this.data.label
          ? new Typo(
              { text: this.data.label },
              {
                typo: theme === 'MarppleShop' ? 'p1' : 'p2',
                weight: theme === 'MarppleShop' ? 'bold' : 'medium',
              },
            )
          : ''}
        ${required ? html`<span class="${klass.dot}"></span>` : ''}
      </label>
      ${this.data.input
        ? html` <div class="${klass.input_container}">${this.data.input ?? ''} ${this.data.button ?? ''}</div> `
        : ''}
    </div> `;
  }

  override onRender() {
    if (this.data.input) {
      this.delegate('click', `.${klass.label}`, this.data.input.focus.bind(this.data.input));
      if (this.data.button) {
        this.delegate('keydown', Input, (e) => {
          if (e.key === 'Enter') {
            e.originalEvent.preventDefault();
            this.data.button?.element().click();
          }
        });
      }
    }
  }
}
